import { Observable } from 'rxjs';

export interface CountersValue {
  dt: string;
  p1: number;
  p2: number;
  rp: number;
  rn: number;
}

// export interface ActivePowerValue {
//   dt: string;
//   Pac: number;
// }

export abstract class CountersData {
  abstract getData(sn: string): Observable<CountersValue[]>;
}
